<template>
  <el-form class="ny-industry" :rules="industryRule" :model="industryForm" ref="industryForm">
    <el-table :data="industryForm.industryData" :rowStyle="rowStyle" v-loading="loading">
      <el-table-column label="资质类型" width="180" align="center">
        <template slot-scope="scope">
          <el-form-item v-if="scope.row.qualification_id === 0">
            <el-input
              v-model="scope.row.qualification_name"
              autosize
              resize="none"
              class="ny-industry__textarea"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <span v-else>{{ scope.row.qualification_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否必填" width="100" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.is_must === 1 ? '必填' : '非必填' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="资质说明" width="240" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.desc }}</span>
        </template>
      </el-table-column>
      <el-table-column label="资质文件" width="180" align="center">
        <template slot-scope="scope">
          <el-form-item
            :prop="'industryData.' + scope.$index + '.qualification_file'"
            :rules="scope.row.is_must === 1 ? industryRule.qualification_file : []"
            :ref="'industryData.' + scope.$index + '.qualification_file'"
          >
            <img
              class="ny-industry__img"
              :src="scope.row.qualification_file"
              alt
              v-if="scope.row.qualification_file"
            />
            <el-button
              :disabled="disabled"
              @click="upload(scope.$index, 'qualification_file', 'industryData.' + scope.$index + '.qualification_file')"
            >选择文件</el-button>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="证件编号" width="200" align="center">
        <template slot-scope="scope">
          <el-form-item
            class="ny-industry__num"
            :prop="'industryData.' + scope.$index + '.number'"
            :rules="industryRule.qualificationNum"
            :label="scope.row.qualification_name.indexOf('营业执照') > -1  ? '社会统一信用编码' : '' "
            v-if="scope.row.qualification_name.indexOf('营业执照') > -1 "
          >
            <el-input
              v-model="scope.row.number"
              autosize
              resize="none"
              class="ny-industry__textarea"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="资质有效期" width="240" align="center">
        <template slot-scope="scope">
          <el-form-item
            :rules="scope.row.date[0] === '-1' || scope.row.is_must !== 1 ? [] : industryRule.date "
            :prop="'industryData.' + scope.$index + '.date'"
            :ref="'industryData.' + scope.$index + '.date'"
          >
            <el-date-picker
              :disabled="disabled"
              class="demonstration"
              v-model="scope.row.date"
              type="daterange"
              placeholder="选择日期范围"
              value-format="yyyy-MM-dd"
              @change="(value) => dateChange(value, scope.row)"
              v-if="scope.row.date[0] !== '-1'"
            ></el-date-picker>
            <el-checkbox-group
              v-model="scope.row.date"
              @change="(value) => changeDateRule(value, scope.row, 'industryData.' + scope.$index + '.date')"
            >
              <el-checkbox label="-1" :disabled="disabled">永久</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="300" align="center">
        <template slot-scope="scope">
          <el-form-item>
            <el-input
              :disabled="disabled"
              type="textarea"
              v-model="scope.row.ext"
              autosize
              resize="none"
              class="ny-industry__textarea input_sm"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column width="142" align="center" fixed="right" v-if="!disabled">
        <template slot-scope="scope">
          <el-button
            class="ny-industry__submit"
            @click="addAualification()"
            v-if="industryForm.industryData.length === (scope.$index + 1)"
          >添加补充资质</el-button>
          <el-button
            v-if="scope.row.qualification_id === 0"
            class="ny-industry__delete"
            @click="handleDelete(scope.row, scope.$index)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-upload class="upload-demo" v-show="false" ref="upload" action :before-upload="beforeUpload"></el-upload>
  </el-form>
</template>

<script>
import { error } from 'util';
export default {
  name: 'Industry',
  componentName: 'Industry',
  components: {
  },
  props: {
    industryData: Function | Array,
    post: Function,
    deleteArray: Array,
    disabled: Boolean,
    loading: Boolean
  },
  data() {
    let changeDate = (rule, value, callback) => {
      if (value && value.length === 2 && value[0] && value[1]) {
        callback()
      } else {
        // console.log('请选择时间!')
        callback(new Error('请选择时间'))
      }
    }
    let qualificationNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入资质编号'));
      } else if (value && value.toString().length > 50) {
        callback(new Error('输入内容不得超过50个字符'))
      } else {
        callback()
      }
    }
    return {
      date: [],
      value1: '',
      checked: true,
      value2: '',
      uploadKey: {
        type: '',
        key: '',
        valid: ''
      },
      industryForm: {
        industryData: undefined
      },
      industryRule: {
        qualificationNum: [{ required: true, validator: qualificationNum, trigger: 'blur' }],
        qualification_file: [{ required: true, message: '请上传图片', trigger: 'change' }],
        date: [{ required: true, validator: changeDate, trigger: 'change' }]
      }
    }
  },
  watch: {
    'industryForm.industryData'(value) {
      this.$emit('update:industryData', value)
    },
    'industryData'(value) {
      this.$set(this.industryForm, 'industryData', this.industryData)
    }
  },
  mounted() {
  },
  methods: {
    rowStyle(row, index) {
      if (index % 2 === 0) {
        return { 'background-color': '#f9f9f9' };
      }
    },
    filterImg(file) {
      let imgType = file.type.split('/')[1]
      let imgTypeArr = ['png', 'jpeg', 'jpg']
      if (imgTypeArr.indexOf(imgType) < 0) {
        this.$message.error('上传图片格式不正确, 请重新上传')
      }
      return imgTypeArr.indexOf(imgType) > -1
    },
    beforeUpload(file) {
      if (!this.filterImg(file)) {
        return false
      }
      let self = this
      this.createReader(file, (w, h, s, url) => {
        if (s > (1024 * 1024 * 2)) {
          self.$message.error({ message: '上传图片不得超过2M' })
          return false
        } else {
          self.sendUpload(file)
        }
      })
      return false
    },
    async sendUpload(file, fileName) {
      let self = this
      let formData = new FormData()
      formData.append('file', file)
      await this.post('/interface/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } }, true).then(res => {
        if (res.code === 1) {
          self.industryForm.industryData = self.industryForm.industryData.map((v, inxdx) => ({
            ...v, qualification_file: inxdx === self.uploadKey.type ? res.data : v.qualification_file
          }))
          this.$nextTick(() => {
            this.$refs['industryForm'].validateField(self.uploadKey.valid, error => { // 处理数据变化页面错误提示为更改
              this.$refs[self.uploadKey.valid].onFieldChange()
            })
          })
        }
      })
    },
    changeDateRule(value, row, field) {
      row.date = row.date.length === 1 ? row.date.indexOf('-1') > -1 ? row.date : ['-1'] : row.date.indexOf('-1') > -1 ? ['-1'] : []
      if (row.date[0] === '-1') {
        this.$nextTick(() => {
          this.$refs['industryForm'].validateField(field, error => {
            this.$refs[field].onFieldChange()
          })
        })
      }
      // this.$refs[field].onFieldChange()
    },
    dateChange(value, row) {
      if (value) {
        row.date = value
      }
    },
    createReader(file, whenReady) {
      let reader = new FileReader()
      reader.onload = function (e) {
        let data = e.target.result
        let img = new Image()
        img.src = data
        img.onload = function () {
          if (whenReady) whenReady(this.width, this.height, file.size, data)
        }
      }
      reader.readAsDataURL(file)
    },
    upload(type, key, valid) {
      this.uploadKey = {
        type: type,
        key: key,
        valid: valid
      }
      this.$refs.upload.$children[0].handleClick()
    },
    handleDelete(row, indexNum) {
      this.industryForm.industryData = this.industryForm.industryData.filter((v, index) => {
        if (v.id && indexNum === index) {
          this.deleteArray.push(v.id)
        }
        return indexNum !== index
      })
    },
    addAualification(formName) {
      let obj = {
        account_id: '',
        date: [],
        desc: '',
        ext: "",
        is_must: '',
        number: "",
        qualification_file: "",
        qualification_id: 0,
        qualification_name: ""
      }
      this.industryForm.industryData.push(obj)
    }
  }
}
</script>

<style lang="scss">
@include b(ny-industry) {
  margin: 30px 50px;
  @include e(textarea) {
    width: 100%;
    height: auto;
  }
  .el-table .el-form-item {
    margin-top: 22px;
    .el-textarea {
      width: 100%;
    }
    .el-form-item__label {
      width: 100%;
      text-align: left;
      left: 12px;
    }
  }
  .el-table {
    .ny-industry__num {
      margin-top: -8px;
    }
  }

  .el-form-item__error {
    width: 100%;
    margin-left: 0px;
    text-align: center;
  }
  .el-table__header-wrapper {
    .cell {
      font-size: 16px;
      font-weight: bold;
    }
  }
  @include e(submit) {
    .cell {
      padding: 0 6px;
    }
  }

  .el-table__body-wrapper,
  .el-table__fixed-body-wrapper {
    .cell {
      white-space: normal;
    }
  }
  @include e(img) {
    width: 100%;
    height: auto;
  }
  @include e(delete) {
    &.el-button {
      margin-top: 6px;
      margin-left: 0px;
    }
  }
  .demonstration {
    margin-top: 28px;
    padding: 0 0;
    width: 220px !important;
  }
}
</style>
